// extracted by mini-css-extract-plugin
export default {"canvas":"Background_canvas__ucuXh"};